import React, { useEffect, useState } from 'react';
import { preferencesPhrasesStorage } from '../../services/preferencesPhrasesStorage';
import PhrasesListItemNumberField from './PhrasesListItemNumberField';
import { useTranslation } from 'react-i18next';
import PhrasesListItemWelcomeIcon from './PhrasesListItemWelcomeIcon';
import Checkbox from "../Checkbox";
import {createValuesString} from "./util";

const PhrasesListItem = ({ preferencePhraseId }) => {
    const { i18n } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);

    const changeSelectedList = () => {
        preferencesPhrasesStorage.changeSelectedPhrasesList(preferencePhraseId);
    };

    const changePhrasesList = () => {
        setIsChecked(preferencesPhrasesStorage.getSelectedList().findIndex(it => it.id === preferencePhraseId) >= 0);
    };

    useEffect(() => {
        preferencesPhrasesStorage.registerFiltersChangingObserver(changePhrasesList);
        return () => {
            preferencesPhrasesStorage.unRegisterFiltersChangingObserver(changePhrasesList);
        };
    }, []);

    return (
        <React.Fragment key={preferencePhraseId + isChecked}>
            <div className="preference__phrases-text-wrapper">
                <Checkbox checked={isChecked} handleChecked={changeSelectedList} />
                <p className="preference__phrases-text">{preferencesPhrasesStorage.getById(preferencePhraseId).content}</p>
            </div>
            <div className="preference__phrases-data">
                {isChecked ? 
                    <p className="block__bullet preference__phrases-values">
                        {createValuesString(preferencesPhrasesStorage.getById(preferencePhraseId), i18n)}
                    </p> 
                    : 
                    null}
                <PhrasesListItemWelcomeIcon preferencePhraseId={preferencePhraseId} />
                <PhrasesListItemNumberField 
                    preferencePhraseId={preferencePhraseId} 
                    ratingValue={preferencesPhrasesStorage.getById(preferencePhraseId).vote}
                    phrasesListManager={preferencesPhrasesStorage}
                />
            </div>
        </React.Fragment>
    );
};

export default PhrasesListItem;
